import React, { useState } from 'react';
import Navbar from './Navbar';
import SideMenu from './SideMenu';

/**
 * Layout component that provides a consistent structure for pages
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to be rendered inside the layout
 * @param {string} props.className - Additional CSS classes for the content container
 * @param {Object} props.style - Additional styles for the content container
 */
function Layout({ children, className = '', style = {} }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div style={{ 
      backgroundColor: '#f5f6f7', 
      height: '100vh',
      display: 'flex', 
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      <Navbar toggleSidebar={toggleSidebar} />
      
      <div style={{ 
        display: 'flex',
        flex: 1,
        marginTop: '48px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <SideMenu isOpen={isSidebarOpen} />
        
        <div 
          className={`layout-content ${className}`}
          style={{ 
            flex: 1,
            marginLeft: isSidebarOpen ? '250px' : '0',
            transition: 'margin-left 0.3s',
            padding: '20px',
            width: '100%',
            overflow: 'auto',
            ...style
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export default Layout;
